export default "__VITE_ASSET__ibFDKA5P__"